<template>
  <el-table
    :data="teams"
    stripe
    size="small"
  >
    <el-table-column
      label="Name"
      prop="name"
    />
    <el-table-column
      label="Code"
      prop="code"
    />
    <el-table-column
      label="Description"
      prop="description"
    />
    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :team="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    teams: {
      type: Array,
      required: true
    }
  }
}
</script>
